var map = {
	"./digital-payment.webp": 73678,
	"./e-commerce-software.jpg": 54124,
	"./e-commerce-software.webp": 86106,
	"./finance-payment.webp": 30846,
	"./finance-software.jpg": 43629,
	"./finance-software.webp": 55934,
	"./healthcare-payment.webp": 24425,
	"./healthcare-software.jpg": 26247,
	"./healthcare-software.webp": 32583,
	"./hhrr-payment.webp": 87189,
	"./law-payment.webp": 34836,
	"./legal-issues-software.jpg": 454,
	"./legal-issues-software.webp": 9819,
	"./marketplaces-software.jpg": 51364,
	"./marketplaces-software.webp": 69640,
	"./retail-payment.webp": 9032,
	"./startups-payment.webp": 85596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79609;